import type { CreateUpdateDocumentsEntity } from './CreateUpdateDocumentsEntity'

export class CreateUpdateDriverDocumentEntity {
  driverId?: number
  documents?: Array<CreateUpdateDocumentsEntity>
}
